<template>
  <!-- Form表单每一条 -->
  <!-- v-if="value" -->
  <div class="formLabel f-r">
    <div class="form-title f-r j-c a-c">{{ name }}</div>
    <div class="form-value f-r j-c a-c">
      {{ value }}
      <span v-if="unit && value !=='0'" class="unit">{{' ' + unit}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    name: String,
    value: [String, Number],
    unit: String
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped>
.formLabel {
  width: 629px;
  height: 50px;
  font-size: 14px;
  border: 1px solid #efefef;
  box-sizing: border-box;
  display: inline-flex;

  .form-title,
  .form-value {
    width: 50%;
    height: 100%;
    box-sizing: border-box;
  }

  .form-title {
    background-color: #f4f5f9;
    border-right: 1px solid #efefef;
  }

  .form-value {
    color: #2d50a1;
    .unit {
      white-space: pre-wrap;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/formLabel.vue